/** API case-request category: Nomination Requests (Case Type 7) */
export const NOMINATION_CATEGORY_CODE = 'NOMINATION';
export const FILE_CATEGORY_NOMINATION = 'Nomination Requests';

/** Set when file categories load from API; used for id-based routing once known. */
export let NOMINATION_CATEGORY_ID = '';

export function setNominationCategoryId(id: string) {
  NOMINATION_CATEGORY_ID = id.trim();
}

export function isNominationCategory(item: {
  id?: string;
  name?: string;
  code?: string;
}): boolean {
  const code = (item.code ?? '').trim().toUpperCase();
  const name = (item.name ?? '').trim().toLowerCase();
  if (code === NOMINATION_CATEGORY_CODE || code.includes('NOMINATION')) return true;
  if (name.includes('nomination')) return true;
  return false;
}

export const NOMINATION_WIZARD_STEPS = [
  { n: 1, lbl: 'Case Overview' },
  { n: 2, lbl: 'Timeline' },
  { n: 3, lbl: 'Submission & Physical File Delivery' },
  { n: 4, lbl: 'Upload Documents' },
] as const;

export type NominationWizardStep = (typeof NOMINATION_WIZARD_STEPS)[number]['n'];
